import { inject, LOCALE_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { iirdsStore } from '../stores/iirds.store';
import { productStore } from '../stores/product.store';
import { logGuardResult } from './guard-logger';

export const setLanguageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const iirds = inject(iirdsStore);
  const product = inject(productStore);
  let language = inject(LOCALE_ID);
  if (route.paramMap.has('language')) {
    language = route.paramMap.get('language') ?? language;
  }
  iirds.setLanguage(language);
  product.setLanguage(language);
  return logGuardResult('setLanguageGuard', true, { language });
};
